import template from './differential-list.html';
import controller from './differential-list.controller';

let differentialListComponent = {
  bindings: {},
  template,
  controller
};

export default differentialListComponent;



// WEBPACK FOOTER //
// ./client/app/components/differential/differential-list.component.js